import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import { query, where, uploadBytesResumable, getDownloadURL, db, collection, addDoc, doc, getDoc, setDoc, getDocs, deleteDoc, updateDoc, writeBatch, limit } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Swal from "sweetalert2";
const Sycron = () => {
    const [loading, setLoading] = useState(
        {
            soal: false,
            Jdwal: false,
            daftarujian: false,
            jawaban: false
        }
    ); // State untuk menyimpan daftar kelas
      const [dataSycron, setDataScron] = useState({
        soal:[],
        ujian: [],
        jawaban:[]
    
        });

      const getDataSycron = useCallback(async () => {
    
            
    
           try {
                    // Kirim request ke server dengan header level user
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/getDataLocal`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                        },
                    });
    
                    if (!response.ok) {
                        throw new Error("Failed to fetch kelas");
                    }
    
                    const data = await response.json();
                    setDataScron(data.data)
    
                } catch (error) {
                   
                }
        }, []);

    const sycronsoal = async (jns) => {
        setLoading({ ...loading, soal: true });

        // Tampilkan Swal awal dengan loading
        Swal.fire({
            title: "Sinkronisasi Data Soal",
            html: "Menyiapkan data...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Ambil data dari koleksi Firestore
            const soalQuery = query(collection(db, "soal"));
            const querySnapshot = await getDocs(soalQuery);
            const firebaseData = [];

            querySnapshot.forEach((doc) => {
                firebaseData.push({ id: doc.id, ...doc.data() });
            });

            console.log(`Total data yang diambil: ${firebaseData.length}`);

            // Fungsi untuk membagi array menjadi chunk berisi 50 soal
            const chunkArray = (arr, size) => {
                return arr.reduce((acc, _, i) => {
                    if (i % size === 0) acc.push(arr.slice(i, i + size));
                    return acc;
                }, []);
            };

            const soalChunks = chunkArray(firebaseData, 5);
            console.log(`Total batch yang akan dikirim: ${soalChunks.length}`);

            let batchSuccess = 0;
            Swal.update({
                title: "Proses Sinkronisasi",
            });
            // Kirim setiap batch secara berurutan
            for (const [index, chunk] of soalChunks.entries()) {
console.log({ data: chunk })

                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/sycronsoal`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
                        },
                        body: JSON.stringify({ data: chunk }),
                    });

                    if (!response.ok) {
                        throw new Error(`Gagal mengirim batch ke-${index + 1}`);
                    }

                    batchSuccess++;
                    Swal.update({
                        html: `Batch ke-${index + 1} berhasil dikirim. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });

                    console.log(`Batch ke-${index + 1} berhasil dikirim.`);
                } catch (error) {
                    console.error(`Error pada batch ke-${index + 1}:`, error);
                    Swal.update({
                        html: `Gagal mengirim batch ke-${index + 1}. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });
                }

                // Delay 1 detik sebelum kirim batch berikutnya
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }

            Swal.fire({
                icon: "success",
                title: "Sinkronisasi Selesai!",
                html: `Total batch sukses: ${batchSuccess} dari ${soalChunks.length}.`,
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "Terjadi kesalahan saat sinkronisasi data.",
            });
        }

        setLoading(false);
    };

    const sycronjawaban = async (jns) => {
        setLoading({ ...loading, soal: true });

        Swal.fire({
            title: "Sinkronisasi Data Soal",
            html: "Menyiapkan data...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Ambil data dari koleksi Firestore
            const soalQuery = query(collection(db, "jawaban"));
            const querySnapshot = await getDocs(soalQuery);
            const firebaseData = [];

            querySnapshot.forEach((doc) => {
                firebaseData.push({ id: doc.id, ...doc.data() });
            });

            console.log(`Total data yang diambil: ${firebaseData.length}`);
            console.log(firebaseData)

            // Fungsi untuk membagi array menjadi chunk berisi 50 soal
            const chunkArray = (arr, size) => {
                return arr.reduce((acc, _, i) => {
                    if (i % size === 0) acc.push(arr.slice(i, i + size));
                    return acc;
                }, []);
            };

            const soalChunks = chunkArray(firebaseData, 10);
            console.log(`Total batch yang akan dikirim: ${soalChunks.length}`);

            let batchSuccess = 0;
            Swal.update({
                title: "Proses Sinkronisasi",
            });
            // Kirim setiap batch secara berurutan
            for (const [index, chunk] of soalChunks.entries()) {
                console.log({ data: chunk })


                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/sycronjawbaan`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
                        },
                        body: JSON.stringify({ data: chunk }),
                    });

                    if (!response.ok) {
                        throw new Error(`Gagal mengirim batch ke-${index + 1}`);
                    }

                    batchSuccess++;
                    Swal.update({
                        html: `Batch ke-${index + 1} berhasil dikirim. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });

                    console.log(`Batch ke-${index + 1} berhasil dikirim.`);
                } catch (error) {
                    console.error(`Error pada batch ke-${index + 1}:`, error);
                    Swal.update({
                        html: `Gagal mengirim batch ke-${index + 1}. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });
                }

                // Delay 1 detik sebelum kirim batch berikutnya
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }

            Swal.fire({
                icon: "success",
                title: "Sinkronisasi Selesai!",
                html: `Total batch sukses: ${batchSuccess} dari ${soalChunks.length}.`,
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "Terjadi kesalahan saat sinkronisasi data.",
            });
        }

        setLoading(false);
    };

    const sycronUjian = async (jns) => {
        setLoading({ ...loading, soal: true });

        Swal.fire({
            title: "Sinkronisasi Data Soal",
            html: "Menyiapkan data...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Ambil data dari koleksi Firestore
            const soalQuery = query(collection(db, "ujian"));
            const querySnapshot = await getDocs(soalQuery);
            const firebaseData = [];

            // Gunakan for...of agar bisa menggunakan await di dalam loop
            for (const doc of querySnapshot.docs) {
                const soalSnapshot = await getDocs(collection(doc.ref, "soal"));

                // Hanya mengambil array ID saja
                const soalData = soalSnapshot.docs.map((soalDoc) => soalDoc.id);

                firebaseData.push({
                    id: doc.id,
                    ...doc.data(),
                    soal: soalData // Hanya menyimpan ID soal
                });
            }

            console.log(`Total data yang diambil: ${firebaseData.length}`);
            console.log(firebaseData);

            // Fungsi untuk membagi array menjadi chunk berisi 50 soal
            const chunkArray = (arr, size) => {
                return arr.reduce((acc, _, i) => {
                    if (i % size === 0) acc.push(arr.slice(i, i + size));
                    return acc;
                }, []);
            };

            const soalChunks = chunkArray(firebaseData, 70);
            console.log(`Total batch yang akan dikirim: ${soalChunks.length}`);

            let batchSuccess = 0;
            Swal.update({
                title: "Proses Sinkronisasi",
            });

            // Kirim setiap batch secara berurutan
            for (const [index, chunk] of soalChunks.entries()) {
                console.log({ data: chunk });

                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/sycronujian`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
                        },
                        body: JSON.stringify({ data: chunk }),
                    });

                    if (!response.ok) {
                        throw new Error(`Gagal mengirim batch ke-${index + 1}`);
                    }

                    batchSuccess++;
                    Swal.update({
                        html: `Batch ke-${index + 1} berhasil dikirim. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });

                    console.log(`Batch ke-${index + 1} berhasil dikirim.`);
                } catch (error) {
                    console.error(`Error pada batch ke-${index + 1}:`, error);
                    Swal.update({
                        html: `Gagal mengirim batch ke-${index + 1}. <br> ${batchSuccess} dari ${soalChunks.length} batch sukses.`,
                    });
                }

                // Delay 1 detik sebelum kirim batch berikutnya
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }

            Swal.fire({
                icon: "success",
                title: "Sinkronisasi Selesai!",
                html: `Total batch sukses: ${batchSuccess} dari ${soalChunks.length}.`,
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "Terjadi kesalahan saat sinkronisasi data.",
            });
        }

        setLoading(false);
    };

  useEffect(() => {
    getDataSycron()
    }, []);


    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card user-activity-card">
                                <div className="card-header"><h5>Sycron Data</h5></div>
                                <div className="card-body">

                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Nama</th>
                                                <th>Data Local</th>
                                                <th>Server</th>
                                                <th>Tindakan</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Daftar Soal</td>
                                                <td>{dataSycron.soal.length||0}</td>
                                                <td></td>
                                                <td>
                                                    <button type="button" onClick={sycronsoal} className="btn btn-danger d-inline-flex"><i className="ti ti-switch-horizontal"></i> Sycron</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Jadwal</td>
                                                <td></td>
                                                <td></td>
                                                <td>
                                                    <button type="button" className="btn btn-danger d-inline-flex"><i className="ti ti-switch-horizontal"></i> Sycron</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Daftar Ujian</td>
                                                <td>{dataSycron.ujian.length||0}</td>
                                                <td></td>
                                                <td>
                                                    <button type="button" onClick={sycronUjian} className="btn btn-danger d-inline-flex"><i className="ti ti-switch-horizontal"></i> Sycron</button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Jawaban</td>
                                                <td>{dataSycron.jawaban.length||0}</td>
                                                <td></td>
                                                <td>
                                                    <button type="button" onClick={sycronjawaban} className="btn btn-danger d-inline-flex"><i className="ti ti-switch-horizontal"></i> Sycron</button>
                                                </td>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sycron;
